import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { actions, useCommon } from '../../../store/common';

export default function ReduxRedirect() {
  const navigate = useNavigate();
  const { redirect } = useCommon();
  const dispatch = useDispatch();

  useEffect(() => {
    if (redirect && redirect.to) {
      navigate(redirect.to, redirect?.options);

      dispatch({
        type: actions.triggerRedirect.toString(),
        payload: null,
      });
    }
  }, [redirect]);

  return null;
}
